require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-fleet-standard-pick-up.json") })
        }
      }, "path---en-fleet-standard-pick-up");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-fleet-standard-pick-up!./.cache/json/en-fleet-standard-pick-up.json
// module id = 1040
// module chunks = 231608221292675